// What app is this? Sent to RAS with every token grant (login, refresh,
// anonymous) and with account creation. RAS puts it in the JWT as a
// `client` claim ({ cb, nb, av, pf }) and stamps users.last_* so support
// can see what each user last ran. Replaces the hardcoded
// `client_version: "6.4.17"` the payloads used to carry.
//
//   client_build  RH_CLIENT_BUILD() — the JS bundle stamp; moves with OTA
//                 bundle updates, not just store releases
//   native_build  CFBundleVersion / versionCode (native only)
//   app_version   marketing version, e.g. 8.6.81 (native only)
//   platform      ios | android | web
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import jwt_decode from "jwt-decode";
import { RH_CLIENT_BUILD } from "./constants";

let nativeInfo = null; // App.getInfo() is static for the process; fetch once

export async function clientInfo() {
  const platform = Capacitor.getPlatform();
  const info = { client_build: RH_CLIENT_BUILD(), platform };
  if (platform !== "ios" && platform !== "android") return info;
  try {
    nativeInfo = nativeInfo || (await App.getInfo());
    info.native_build = nativeInfo.build;
    info.app_version = nativeInfo.version;
  } catch (e) {
    // Old shell without the plugin; RAS treats missing fields as unknown.
  }
  return info;
}

// The client_build a token was minted with, or null if it predates the
// claim. Used after an OTA bundle swap to notice the token is stale.
export function tokenClientBuild(token) {
  try {
    return jwt_decode(token)?.client?.cb ?? null;
  } catch (e) {
    return null;
  }
}
